var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c("v-card-title", { staticClass: "pt-0 pb-2" }, [
            _c(
              "h4",
              { staticClass: "text-h6 mt-3" },
              [
                _c("base-switch", {
                  attrs: {
                    "input-value": _vm.backupSrv.backupSettings.enabled,
                    rules: "required",
                    name: "enabled",
                    label: _vm.$t("Dialogs.BackupSettings.EnableBackups"),
                  },
                  on: {
                    "update:inputValue": function ($event) {
                      return _vm.$set(
                        _vm.backupSrv.backupSettings,
                        "enabled",
                        $event
                      )
                    },
                    "update:input-value": function ($event) {
                      return _vm.$set(
                        _vm.backupSrv.backupSettings,
                        "enabled",
                        $event
                      )
                    },
                  },
                }),
              ],
              1
            ),
            _c(
              "span",
              { staticClass: "ml-auto" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "white--text",
                    attrs: { color: "admin-primary " },
                    on: { click: _vm.createBackup },
                  },
                  [
                    _vm._v(" Create Backup "),
                    _c("v-icon", { staticClass: "ml-1" }, [
                      _vm._v("mdi-backup-restore"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [_c("v-divider")],
                        1
                      )
                    : _vm._e(),
                  _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("base-select", {
                            attrs: {
                              value: _vm.backupSrv.backupSettings.frequency,
                              items: _vm.frequencies,
                              rules: "required",
                              name: "frequency",
                              label: _vm.$t("Dialogs.BackupSettings.Frequency"),
                              clearable: "",
                              multiple: false,
                              "return-object": false,
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(
                                  _vm.backupSrv.backupSettings,
                                  "frequency",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("base-text-field", {
                            attrs: {
                              value: _vm.backupSrv.backupSettings.time,
                              rules: "required",
                              name: "time",
                              label: _vm.$t("Dialogs.BackupSettings.Time"),
                              placeholder: "HH:mm",
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(
                                  _vm.backupSrv.backupSettings,
                                  "time",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isWeekly && _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("base-select", {
                            attrs: {
                              value: _vm.backupSrv.backupSettings.dayOfWeek,
                              items: _vm.daysOfWeek,
                              "item-text": "key",
                              "item-value": "value",
                              rules: "required",
                              name: "dayOfWeek",
                              label: _vm.$t("Dialogs.BackupSettings.DayOfWeek"),
                              clearable: "",
                              multiple: false,
                              "return-object": false,
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(
                                  _vm.backupSrv.backupSettings,
                                  "dayOfWeek",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isYearly && _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("base-select", {
                            attrs: {
                              value: _vm.backupSrv.backupSettings.monthOfYear,
                              items: _vm.monthsOfYear,
                              "item-text": "key",
                              "item-value": "value",
                              rules: "required",
                              name: "monthOfYear",
                              label: _vm.$t(
                                "Dialogs.BackupSettings.MonthOfYear"
                              ),
                              clearable: "",
                              multiple: false,
                              "return-object": false,
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(
                                  _vm.backupSrv.backupSettings,
                                  "monthOfYear",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.isMonthly || _vm.isYearly) &&
                  _vm.backupSrv.backupSettings.enabled
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("base-text-field", {
                            attrs: {
                              value: _vm.backupSrv.backupSettings.dayOfMonth,
                              type: "number",
                              rules: "required|min:1|max:31",
                              name: "dayOfMonth",
                              label: _vm.$t(
                                "Dialogs.BackupSettings.DayOfMonth"
                              ),
                            },
                            on: {
                              "update:value": function ($event) {
                                return _vm.$set(
                                  _vm.backupSrv.backupSettings,
                                  "dayOfMonth",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-col",
                    { staticClass: "text-right", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary" },
                          on: { click: _vm.saveSettings },
                        },
                        [_vm._v(_vm._s(_vm.$t("Common.Save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }